import { ApplicationState } from './types';

export const initialState: ApplicationState = {
    app_id: '',
    app_name: '',
    app_status: '',
    region: '',
    is_chats_enabled: false,
    is_chat_bot_enabled: false,
    is_calls_enabled: false,
    is_scheduled_calls_enabled: false,
    is_notifications_enabled: false,   
    is_export_data_access_enabled: false,
    is_chat_analytics_enabled: false,
    is_call_analytics_enabled: false,
    is_sentiment_analysis_enabled: false,
    is_user_analytics_enabled: false,
    is_fetch_data: false,
    primary_color: '#1976d2',
    secondary_color: '#dc004e',
};